module.exports = __webpack_public_path__ + "static/media/data~tHUHAyCj.0ed67368.svg";